<template>
  <div>
    <!--<ModalConfirmacion titulo="titulo" cuerpo="cuerpo" ref="modalConfirmacion"></ModalConfirmacion>-->
    <div slot="title">
      <h2 class="label-black">Catalogo de Preguntas</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row" style="margin-top:20px;">
          <div class="col-3">
            <router-link to="/SISEVA/NuevaPregunta">
              <input type="button" class="form-control btn-custom" value="Nueva Pregunta" />
            </router-link>
          </div>
        </div>


        <div class="row" style="margin-top:50px;">
          <div class="col-12 table-responsive">
            <table class="table table-striped table-light table-hover table-sm" id="tablaPreguntas">
              <thead class="thead-custom">
                <tr>
                  <th>Categoría</th>
                  <th>Competencia</th>
                  <th>Pregunta</th>
                  <th>Cardinalidad</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody class='text-dark'>
                <tr v-for='pregunta in preguntas' v-bind:id='pregunta.PreguntaId'>
                  <td>{{pregunta.CategoriaCompetencia}}</td>
                  <td>{{pregunta.CompetenciaPregunta}}</td>
                  <td>{{pregunta.DescripcionPregunta}}</td>
                  <td>{{pregunta.Cardinalidad}}</td>
                  <td class='d-flex justify-content-around'>
                    <i class='fa fa-edit' @click='editarPregunta(pregunta.PreguntaId)' />
                    <i class='fa fa-question-circle' @click='mostrarRespuestas(pregunta.PreguntaId,pregunta.Respuesta1,pregunta.Respuesta2,pregunta.Respuesta3,pregunta.Respuesta4)' />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'
  import catalogos from '@/../static/js/catalogos'
  export default {
    data() {
      return {
        preguntas: []
      }
    },
    components: {
      ModalConfirmacion: catalogos.SISEVA.ModalConfirmacion
    },
    methods: {
       buscarPreguntas: function () { //Retorna una lista de cuestionarios en base a ciertos filtros
        //Carga la información necesaria para hacer la petición
        var peticion = {
          "esPrueba": false,
          "textoBusqueda": "",
          "competenciaId": null,
          "tipoCuestionario": null
        };
        //console.log(peticion)
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.GetPreguntas, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
              this.preguntas = response.data.Preguntas//Carga los datos necesarios
            this.$nextTick(() => {
              PaginarTabla('tablaPreguntas', 10)
            })
            comun.SeEstaCargandoInformacion(false);
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },
      editarPregunta: function (idPregunta) {
        this.$router.push({
          name: 'EditarPregunta',
          params: { idPregunta: idPregunta}
        })
      },
      mostrarRespuestas: function (PreguntaId, Respuesta1, Respuesta2, Respuesta3, Respuesta4) {
        $("#fila-respuestas").remove();
        $('#' + PreguntaId).after('<tr id="fila-respuestas"><td></td><td><div>Respuestas :</div></td><td colspan="3">' +
          '<div><ol><li>' + Respuesta1 + '</li>' +
          '<li>' + Respuesta2 + '</li>' +
          '<li>' + Respuesta3 + '</li>' +
          '<li>' + Respuesta4 + '</li></ol></div>' +
          '</td></tr>');
        var cosa = $('#' + PreguntaId).next()
        console.log(cosa)
        cosa.focus()
        cosa.toggleClass('transition')
      }

    }, mounted: function () {
      this.buscarPreguntas();
    }

  }

</script>

<style scoped>

  #fila-respuestas div{
    max-height: 0px;
    overflow: hidden;
    transition: max-height 1.5s ease;
  }
  #fila-respuestas.transition div{
    max-height: 400px;
  }
  .thead-custom {
    background-color: #004746;
    color: white;
  }
  .custom-area {
        background-color: #7e7f74;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Psicologia/CatalogoPreguntas.vue